function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.03 22L4 12H0V8h4V5.5C4 1.79 6.3 0 9.6 0c1.6 0 2.96.12 3.36.17v3.88h-2.3c-1.8 0-2.15.86-2.15 2.11V8h5.24l-2 4H8.51v10H4.03z",
  fill: "#2A3449"
});

function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 22"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQuMDMgMjJMNCAxMkgwVjhoNFY1LjVDNCAxLjc5IDYuMyAwIDkuNiAwYzEuNiAwIDIuOTYuMTIgMy4zNi4xN3YzLjg4aC0yLjNjLTEuOCAwLTIuMTUuODYtMi4xNSAyLjExVjhoNS4yNGwtMiA0SDguNTF2MTBINC4wM3oiIGZpbGw9IiMyQTM0NDkiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvc3ZnPg==";
export { SvgFacebookLogo as ReactComponent };